module.exports = __webpack_public_path__ + "media/images/landings/promotion_2/ogp-f3ca7d8427437ed36310b8e692531077.png";